import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

//width,height와 size변수 통합해야될 것

const IconWrapper = styled.div`
  border: none;
  object-fit: cover;
  ${({ iconSize }) => `
  width: ${iconSize}px;
  height: ${iconSize}px;
`};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'cursor')};
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`;

const Icon = ({ clickable, style, className, alt, src, onClick, iconSize }) => {
  const handleClick = (e) => {
    onClick && onClick(e);
  };

  return (
    <IconWrapper
      style={style}
      onClick={handleClick}
      className={className}
      iconSize={iconSize}
      clickable={clickable}
    >
      <Img alt={alt} src={src} />
    </IconWrapper>
  );
};

Icon.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  iconSize: PropTypes.number,
  clickable: PropTypes.bool,
};

export default Icon;
